var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 347.8 144.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.7,21.1V2.9h-36.3v19.9c12-1,24.1-1.5,36.3-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.4,28.7v63.8c0,2.5-1,3.7-2.9,3.7-.7,0-1.3-.1-1.8-.3-.5-.2-1.1-.7-1.6-1.3l-47-56.2c-12.6,2.9-25.1,6.2-37.3,9.9l73.8,85.3c3.3,3.8,7.2,6.6,11.6,8.3s9.6,2.6,15.5,2.6c3.4,0,6.7-.6,9.8-1.7,3.2-1.2,5.9-2.9,8.3-5.3,2.4-2.4,4.3-5.5,5.8-9.2,1.4-3.8,2.2-8.2,2.2-13.4V25.3c-12.3.7-24.5,1.9-36.4,3.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,130.2c.6.7,1.3,1.3,1.9,1.9,12.4-8.9,25.6-17.6,39.7-26.1h-1.9c-4.8,0-8-.9-9.7-2.8-1.7-1.8-2.6-5.3-2.6-10.3V3.1H0v93.3c0,7.5.8,14.1,2.3,19.8s4,10.3,7.5,14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.8,49.5V3.1h-37.2v59.8c12-4.8,24.4-9.3,37.2-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,79.1v62.3h37.2V63.5c-12.7,4.8-25.1,10.1-37.2,15.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2,106h-35.4c-19.4,11-37.7,22.6-54.6,34.4,4.1.7,8.8,1,13.9,1h76.1v-35.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.2,57.1v84.3h17.8V51.2c-6,1.9-11.9,3.8-17.8,5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.6,13.7c-4.4-5-8.8-8.6-13.3-10.6s-10-3.1-16.6-3.1c-4.6,0-8.9.6-12.9,1.7-.2.1-.4.1-.7.2v42.3c2.1-.6,4.2-1.2,6.4-1.8,16.5-4.6,33.7-8.5,51.2-11.7l-14.1-17h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoSmall);
export default __webpack_public_path__ + "static/media/header_logo_small.9164bf44ec07af6a7812dea270c43460.svg";
export { ForwardRef as ReactComponent };